import { render, staticRenderFns } from "./abnormalList.vue?vue&type=template&id=01defc4e"
import script from "./abnormalList.vue?vue&type=script&lang=js"
export * from "./abnormalList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports